/* @fflow */

import React, { createRef } from 'react';

let baseStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  opacity: 0,
  width: '100%',
  height: '200%',
  marginTop: '-20px',
  zIndex: 1,
  cursor: 'pointer'
};

const FileInput = ({
    multiple = true,
    addFiles,
    ALLOWED_FILE_TYPES= [],
    customDataTestID
  }) => {
  const inputRef = createRef();

  const handleOnChange = (event) => {
    let files = [];
    for (let i = 0; i < event.target.files.length; i++) {
      files.push(event.target.files[i]);
    }
    addFiles(files);

    /*
     *  In IE, changing the input refires `onchange` with an empty file
     *  Without resetting the input, you cannot submit the same file twice.
     */

    if (!('ActiveXObject' in window)) {
      inputRef.current.value = ``;
    }
  }

  return (
    <input
      data-testid={customDataTestID}
      ref={inputRef}
      id="file-input"
      type="file"
      name="files[]"
      multiple={multiple}
      accept={ALLOWED_FILE_TYPES.map(f => f.replace(/^[^.]/, m => `.${m}`)).join(',')}
      title="File Input"
      onChange={handleOnChange}
      style={baseStyle}
    />
  );
}

export default FileInput;
